/**
 * Shop By Category Section JavaScript
 * Consolidated navigation logic for all arrow types and scroll functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  const scrollContainer = document.getElementById('category-scroll-container');
  // Removed scroll dots; only arrows/keyboard/touch navigation remain

  if (!scrollContainer) return;

  // Responsive scroll amount
  function getScrollAmount() {
    const page = scrollContainer.querySelector('.mobile-card-page');
    return window.innerWidth < 768 && page ? page.getBoundingClientRect().width + 16 : 300;
  }

  // Generic scroll function to eliminate duplication
  function scrollLeft() {
    scrollContainer.scrollBy({
      left: -getScrollAmount(),
      behavior: 'smooth'
    });
  }

  function scrollRight() {
    scrollContainer.scrollBy({
      left: getScrollAmount(),
      behavior: 'smooth'
    });
  }

  // Visual states are handled in CSS :hover/:focus-visible to avoid JS style manipulation

  // Consolidated event listener setup for consistent navigation arrows
  function setupArrowListeners() {
    // Main navigation arrows (consistent with Best Sellers)
    const prevBtn = document.getElementById('shop-by-category-prev');
    const nextBtn = document.getElementById('shop-by-category-next');
    
    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', scrollLeft);
      nextBtn.addEventListener('click', scrollRight);
    }
  }


  // Keyboard navigation support
  function setupKeyboardNavigation() {
    document.addEventListener('keydown', function(event) {
      if (event.target.closest('.shop-by-category-section')) {
        switch(event.key) {
          case 'ArrowLeft':
            event.preventDefault();
            scrollLeft();
            break;
          case 'ArrowRight':
            event.preventDefault();
            scrollRight();
            break;
        }
      }
    });
  }

  // Touch/swipe support for mobile
  function setupTouchNavigation() {
    let startX = 0;
    let startY = 0;
    let isScrolling = false;

    scrollContainer.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isScrolling = false;
    }, { passive: true });

    scrollContainer.addEventListener('touchmove', function(e) {
      if (!isScrolling) {
        const deltaX = Math.abs(e.touches[0].clientX - startX);
        const deltaY = Math.abs(e.touches[0].clientY - startY);
        
        if (deltaX > deltaY) {
          isScrolling = true;
        }
      }
    }, { passive: true });
  }

  // Initialize all functionality
  function init() {
    setupArrowListeners();
    setupKeyboardNavigation();
    setupTouchNavigation();
  }

  // Start the magic
  init();
});
